import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class CompaniesImportRequest extends GenericRequest {

    term;
    page;

    constructor(page = 1, term = '') {
        super(METHOD_POST, ApiEndpoints.COMPANIES_IMPORT);

        this.page = page;
        this.term = term;
    }

    overrideRequest() {
        return {
            criteria: {
                term: this.term,
                page: this.page,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/outsource/ws/CompaniesImportRequest.js